module.exports = __webpack_public_path__ + "static/media/Illus-BowlFull@2x.cc698b61.png";